import { authApiBasePath } from '@calorie-tracker/auth';

const requiredAuthorizationParameters = ['client_id', 'redirect_uri', 'code_challenge'] as const;

export function getMcpAuthorizationContinuation(search: string): string | null {
  const parameters = new URLSearchParams(search);

  if (parameters.get('response_type') !== 'code') {
    return null;
  }

  if (parameters.get('code_challenge_method')?.toUpperCase() !== 'S256') {
    return null;
  }

  if (requiredAuthorizationParameters.some((parameter) => !parameters.get(parameter)?.trim())) {
    return null;
  }

  return `${authApiBasePath}/mcp/authorize?${parameters.toString()}`;
}
